export default "__VITE_ASSET__DbDlSc7i__"